import { render, staticRenderFns } from "./SmartSearchResultsTable.vue?vue&type=template&id=b579fdb8"
import script from "./SmartSearchResultsTable.vue?vue&type=script&lang=js"
export * from "./SmartSearchResultsTable.vue?vue&type=script&lang=js"
import style0 from "./SmartSearchResultsTable.vue?vue&type=style&index=0&id=b579fdb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports